require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/fn/object/assign.js
// module id = OL57
// module chunks = 15